import { defineStore } from "pinia";
import { deleteCookie, getCookie } from "@/use/useCookie";
import { APP_AUTH, TP_COOKIE_NAME } from "@/env_config";

const envAuth: string | undefined = APP_AUTH;
const envCookieName: string | undefined = TP_COOKIE_NAME;

interface AuthStoreState {
  authenticated: boolean;
}

export const useAuthStore = defineStore("auth", {
  state: (): AuthStoreState => ({
    authenticated: false
  }),
  getters: {
    isLoggedIn: state => state.authenticated
  },
  actions: {
    checkAuth() {
      if (envAuth === "true" || typeof envAuth === "undefined") {
        const cookieValue = getCookie(envCookieName ? envCookieName : "");
        this.authenticated = !!cookieValue;
      } else {
        this.authenticated = true;
      }
    },
    logOut() {
      deleteCookie(envCookieName ? envCookieName : "");
      this.authenticated = false;
    }
  }
});
